import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { XCircle } from 'lucide-react';

const SubscriptionCancelledPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-blue-50 flex items-center justify-center px-4">
      <Card className="p-12 text-center max-w-md">
        <XCircle className="w-16 h-16 text-orange-500 mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-slate-900 mb-2">
          Subscription Cancelled
        </h2>
        <p className="text-slate-600 mb-6">
          You've cancelled the subscription process. No charges have been made.
        </p>
        <p className="text-slate-600 mb-6">
          You can still use your 7-day free trial. Would you like to try again or continue exploring?
        </p>
        <div className="space-y-3">
          <Button
            onClick={() => navigate('/subscription')}
            className="w-full bg-purple-600 hover:bg-purple-700"
          >
            View Plans Again
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate('/dashboard')}
            className="w-full"
          >
            Continue with Trial
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default SubscriptionCancelledPage;
